import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { ToastrService } from 'ngx-toastr';
import { faHeartbeat } from '@fortawesome/free-solid-svg-icons';

import { UserPreferenceService } from '../../service/user-preference.service';

@Component({
  selector: 'mc-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {

  heartbeat = faHeartbeat;

  constructor(
    public authService: AuthService,
    private router: Router,
    private notifService: ToastrService,
    private prefService: UserPreferenceService
  ) { }

  signOut(): void {
    this.authService.signOut().subscribe(
      res => this.router.navigate(['login'])
    );
  }

  updateUseHeaders(): void {
    let newValue = !this.authService.useHeaders();
    let userId = this.authService.currentUser.id;
    this.prefService.updateUserPreference(userId, 'use_headers', newValue).subscribe(
      user => {
        this.authService.currentUser = user;
        this.notifService.success('Configuração realizada');
      },
      err => {
        this.notifService.error('Falha na configuração');
      }
    );
  }

  refreshBrowserPage(): void {
    window.location.reload();
  }
}
